import React, {useState, useEffect, useCallback, useRef} from 'react'
import {Input, message, Button, Space} from 'antd'
import {CloseOutlined} from '@ant-design/icons'
import DraggableModal from "../../components/DraggableModal";
import JobFairApi from "../../api/jobfair";
import {emptyValidate} from "../../util/validate";

export default function CreateJobfairModal({onClose,onRemove, isShow, data={}}) {
    const [isOpen, setIsOpen] = useState(false)
    const [name, setName] = useState()
    const [themeCode, setThemeCode] = useState()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (isShow) {
            if (data && !!data.id) {
                setName(data.name)
                setThemeCode(data.themeCode)
            }

        } else {
            setName()
            setThemeCode()
        }
        setIsOpen(isShow)
    }, [isShow])


    const save = useCallback(() => {
        let validateResult = emptyValidate(name, '请填写招聘会标题')
            || emptyValidate(themeCode, '请选择页面样式！');

        if (validateResult) {
            return;
        }
        JobFairApi.createUpdateJobFair({
            id: data.id,
            name,
            themeCode
        }).then(resp=>{
            if (resp.resultCode === 1) {
                message.success(resp.resultMessage)
                onClose(true)
            }
        })

    })


    return (
        <DraggableModal
            title="修改宣传页面"
            open={isOpen}
            onOk={save}
            onCancel={() => onClose()}
            width={560}
            okText="保存"
            footer={null}
            maskClosable={false}
        >
            <div className="white-bg mgt32 pdb40 pdh24">
                <div className="gray-dark mgb8">招聘会标题</div>
                <Input
                    style={{width: 440}}
                    value={name}
                    placeholder="请填写"
                    maxLength={120}
                    onChange={(e) => setName(e.target.value)}/>

                <div className="gray-dark mgt32 mgb8">页面样式</div>
                <div className="flexbox">
                    <span
                        onClick={()=>setThemeCode(1)}
                        className={className(["fts-13", "pdh20","pdv6","inline-block","border","border-radius",
                            "mgr40",themeCode===1?'green-bg white':'cursor'])}
                    >样式一</span>
                    <span
                        onClick={()=>setThemeCode(2)}
                        className={className(["fts-13", "pdh20", "pdv6","inline-block","border","border-radius",
                            themeCode===2?'orange-bg white':'cursor'])}
                    >样式二</span>
                </div>
            </div>
            <div className="flexbox justifyCenter mgt24">
                <Space>
                    <Button key="submit" type="primary" loading={loading} onClick={save}>
                        保存
                    </Button>
                    <Button key="cancel" onClick={()=>onClose()}>
                        取消
                    </Button>
                </Space>
            </div>
        </DraggableModal>)
}

function className (arr=[]) {
    return arr.join(' ')
}
